var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?[_c('v-skeleton-loader',{attrs:{"type":"image","width":"100%;"}})]:[_c('v-img',{attrs:{"src":_vm.base64Image}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }